import axios from 'axios'
import store from '@/globalvar.js'


// Esto puedo necesitarlo cuando implemente el login
// import { StorageService } from '../services/storage.service'

import StorageService from '@/services/storage.service'
//let timeout = null;
let pendingRequests = 0;
const ApiService = {
  APIURL: '',  
 
  
   /*startLoading() {
  pendingRequests++;
   console.log("++");
  console.log(pendingRequests);
  console.log(timeout);
  if (!timeout) {
    timeout = setTimeout(() => {
      store.commit('SET_LOADING', true);
    }, 200)
  }
},

 endLoading() {
  if (pendingRequests > 0) {
    pendingRequests--;
  }
   console.log("--");
   console.log(pendingRequests);
  if (pendingRequests === 0) {
    clearTimeout(timeout);
    timeout = null;
    console.log("False");
    store.commit('SET_LOADING', false);
  }
},*/

    startLoading() {
      pendingRequests++
      store.commit('SET_LOADING', true)
    },
    endLoading() {
      if (pendingRequests > 0) pendingRequests--

      if (pendingRequests === 0) {
        store.commit('SET_LOADING', false)
      }
    },

  init(baseURL) {
    this.APIURL = baseURL
    axios.defaults.baseURL = baseURL;
    store.commit('setApiUrl',baseURL);
    
    
    axios.interceptors.request.use(config => {
      if (!config.DisableLoading) {
        this.startLoading();
      }
      var token = StorageService.getOnlyToken();
      if (token) {
          config.headers.Authorization = `Bearer ${token}`;
      }  
      const routeName = window?.appVueRouter?.currentRoute?.value?.name || (window.location.pathname);
      if (routeName) {
        config.headers['X-View-Name'] = routeName;
      }      
      return config;
    },
      error => {
        this.endLoading()
        return Promise.reject(error)
      }
  );
  
   // console.log(window.location.pathname);
   // console.log(StorageService.IsSetupUser())

    /*if(StorageService.IsSetupUser() && (!window.location.pathname.includes("setup") && !window.location.pathname.includes("main") && !window.location.pathname.includes("unauthorized") )){
      window.location = '/unauthorized?u='+StorageService.getName();
    }*/

   axios.interceptors.response.use(response => {
      this.endLoading();
      return response;
    }, error => {
       this.endLoading();
      if(error.response && 401 === error.response.status) {        
        if (error.response.data && error.response.data.errorMessage == "Select Provider") {
          window.location = '/provider';                 
        } else {
          var uname = StorageService.getName();
          if ( uname == null ) {
            uname = "user";
          }
          // StorageService.removeToken(); 
          store.commit('setAccessToken','');
          localStorage.removeItem("vuex");
          localStorage.removeItem("_secure__ls__metadata");
          window.location = '/unauthorized?u='+uname;                 
        }        
        return error.response.statusText;
      } else {      
        return Promise.reject(error);
      }      
    });
  },

 

    setHeader() {

    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource) { 
        return axios.get(resource,{
            headers: {}
          })
    },

    getData(resource, data) { 
        return axios.get(resource, data)
    },

    post(resource, data) {
        return axios.post(resource,data,{
          headers: {}
        })
    },

    put(resource, data) {
        return axios.put(resource, data,{
          headers: {}
        })
    },

    delete(resource, data) {
        return axios.delete(resource, { data: data },{
            headers: {}
          })
    },

      /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data) {
        var result = axios(data);
        return result;
    },

    parseParams(params) {
      const keys = Object.keys(params)
      let options = ''
    
      keys.forEach((key) => {
        const isParamTypeObject = typeof params[key] === 'object'
        const isParamTypeArray = isParamTypeObject && params[key] && params[key].length >= 0
    
        if (!isParamTypeObject) {
          options += `${key}=${params[key]}&`
        }
    
        if (isParamTypeObject && isParamTypeArray) {
          params[key].forEach((element) => {
            options += `${key}=${element}&`
          })
        }
      })    
      return options ? options.slice(0, -1) : options
    },

    getWithArray(resource,data) {     
      return axios.get(resource, {
        params: data,
          paramsSerializer: (params) => this.parseParams(params)
        }
      )
    },
}

export default ApiService